import { gql } from '@apollo/client'

export default gql`
  query mapLocationGroupsQuery(
    $fromDate: DateTime!
    $toDate: DateTime!
    $marketId: Int
  ) {
    mapLocationGroups(
      fromDatetime: $fromDate
      toDatetime: $toDate
      marketId: $marketId
    ) {
      title
      address
      # latitude, longitude, fromTime and toTime
      # are required for proper key construction,
      # keep them
      latitude
      longitude
      fromTime
      toTime
      items {
        id
        type
        allowOrders
        startTime
        endTime
        latitude
        longitude
        lotId
        truckId
        lotName
        lotPath
        locationPath
        truckScheduleUrl
        restaurantLogo {
          thumb
        }
        fullAddress
        truckName
      }
    }
  }
`
